import { atom } from 'jotai';
import type { WizardStep } from '../pages/goods-receiving/hooks/wizard-steps';

/**
 * Last goods-receiving wizard step the user saw. Every step route mounts its
 * own `WizardLayout`, so no React state survives a step change: the layout
 * compares this value with the new step to know which way to animate.
 * In memory only on purpose — after a reload the first step must not animate.
 */
export const lastVisitedWizardStepAtom = atom<WizardStep | null>(null);
